import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bookedEvent: {},
  notificationStatus:false,
  hasNotificationEnabled:false
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setBookedEvents: (state, action) => {
      state.bookedEvent = action.payload;
    },
    setNotificationStatus: (state, action) => {
      state.notificationStatus = action.payload;
    },
    updateNotificationStatus:(state,action)=>{
      state.hasNotificationEnabled=action.payload
    }
  },
});

export const { setBookedEvents,setNotificationStatus,updateNotificationStatus} = dashboardSlice.actions;

export default dashboardSlice.reducer;
